import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';


class QCPointServices {

  createQCPoint = async (payload) => {
    const qcPoint = await Helpers.post({
      url: Constants.QC_POINTS,
      data: payload,
    });
    return qcPoint;
  }


updateQCPoint = async (payload) => {
  const qcPoint = await Helpers.put({
    url: Constants.QC_POINTS,
    data: payload,
  });
  return qcPoint;
}


updateQCPointProduct = async (payload) => {
  const qcPoint = await Helpers.put({
    url: Constants.UPDATE_QC_POINT_PRODUCT,
    data: payload,
  });
  return qcPoint;
}


  deleteQCPoint = async (payload) => {
    const qcPoint = await Helpers.delete({
      url: Constants.QC_POINTS,
      data: payload,
    });
    return qcPoint;
  }

  /**
 *
 * @param {*} payload
 * @return
 */
  deleteQCPointGroup = async (payload) => {
    const qcPoint = await Helpers.delete({
      url: Constants.DELETE_QC_POINTS_GROUP,
      data: payload,
    });
    return qcPoint;
  }

  getQCPoints = async (tenantId, groupId, operation, productSkuId, accessControl, departmentId, sellerId, category, page, limit, searchKeyword, defaultAssigneeId, controlPer, qcVerificationType) => {
    let url = `${Constants.QC_POINTS}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (groupId) url += `group_id=${groupId}&`;
    if (operation) url += `operation=${operation}&`;
    if (controlPer) url += `control_per=${controlPer}&`;
    if (qcVerificationType) url += `qc_verification_type=${qcVerificationType}&`;
    if (productSkuId) url += `product_sku_id=${productSkuId}&`;
    if (accessControl) url += `access_control=${accessControl}&`;
    if (departmentId) url += `department_id=${departmentId}&`;
    if (sellerId) url += `seller_id=${sellerId}&`;
    if (category) url += `category=${category}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (defaultAssigneeId) url += `default_assignee_ids=${defaultAssigneeId}&`;

    const qcPoints = await Helpers.get({ url });
    return qcPoints;
  }

  getQCPointsReport = async (tenantId, selectedEmails, userId) => {
    let url = `${Constants.DOWNLOAD_QC_POINTS}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (selectedEmails) url += `emails=${selectedEmails}&`;
    if (userId) url += `user_id=${userId}&`;
    const QCPReport = await Helpers.get({ url });
    return QCPReport;
  }
}

export default new QCPointServices();
